import { useContext, useEffect } from "react";
import { useCommerciaux } from "../../../../../../../hooks/fetchers/useCommerciaux/useCommerciaux";
import { CommercialEnabledFilters } from "../../DashboardCommerciaux.types";
import Button from "../../../../../../designSystem/Button/Button";
import { useMutation, useQueryClient } from "react-query";
import { BaseResponse } from "../../../../../../../types/api/api.types";
import { AssignAllProspectsQueryParams } from "./AssignProspectsTable.types";
import { ASSIGN_ALL_PROSPECT_QUERY_KEY, assignAllProspectsQuery } from "./AssignProspectsTable.query";
import { useNavigate } from "react-router-dom";
import { useMergedStatesFromFetchers } from "../../../../../../../hooks/useMergedStatesFromFetchers/useMergedStatesFromFetchers";
import Loading from "../../../../../../commons/Loading/Loading";
import { DashboardCommerciauxContext } from "../../DashboardCommerciaux.context";

export default () => {

  const navigate = useNavigate()

  const queryClient = useQueryClient()

  const { selectedCOM } = useContext(DashboardCommerciauxContext)

  const {
    data: commerciaux,
    refetch: refetchCommerciaux,
    isLoading: isCommerciauxLoading,
    // error,
  } = useCommerciaux({ 
    page: 1, 
    perPage: 1000, 
    enabled: CommercialEnabledFilters.Oui 
  });

  useEffect(() => {
    refetchCommerciaux()
  }, [selectedCOM])

  const { mutate: assignProspect, isLoading: isAssignProspectLoading } = useMutation<
    Awaited<BaseResponse>,
    Error,
    AssignAllProspectsQueryParams
  >((data) => assignAllProspectsQuery(data), {
    mutationKey: ASSIGN_ALL_PROSPECT_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: () => {
      navigate(0)
    },
    onError: (error) => {
      console.log('error', error);
    },
  });

  const { isLoading } = useMergedStatesFromFetchers({ loadings: [isCommerciauxLoading, isAssignProspectLoading] })

  if (isLoading) return <Loading />

  return (
    <table className="dashboard__table" style={{ flex: 0, width: '100%' }}>
      <thead>
        <tr>
          <th>Commercial</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {commerciaux?.results.map(({ id, firstName, lastName }, index) => {
          return (
            <tr key={index}>
              <td>{firstName} {lastName}</td>
              <td
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}
              >
                <Button
                  onClick={() => {
                    if (selectedCOM) {
                      assignProspect({
                        newCommercialId: id,
                        oldCommercialId: selectedCOM.id
                      })
                    }
                  }}
                  disabled={id === selectedCOM?.id}
                >
                  Assigner
                </Button>
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
    )

}